import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=e3a9db54"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3a9db54')) {
      api.createRecord('e3a9db54', component.options)
    } else {
      api.reload('e3a9db54', component.options)
    }
    module.hot.accept("./reset-password.vue?vue&type=template&id=e3a9db54", function () {
      api.rerender('e3a9db54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/reset-password.vue"
export default component.exports